import React from 'react';
import LegalDocumentEditor from '../legal-document/LegalDocumentEditor';
import refundReturnApi from '../../services/refundReturnApi';

const DEFAULT_DOCUMENT = {
  title: 'KaamDhanda Return, Refund & Cancellation Policy',
  company: 'Nirvighna Services Private Limited',
  sections: [],
};

const RefundReturnEditor = () => (
  <LegalDocumentEditor
    permissionName="Refund & Return"
    pageTitle="Refund & Return Policy Editor"
    pageDescription="Edit the refund and return policy JSON document served by the public API."
    saveSuccessMessage="Refund & Return Policy saved successfully!"
    defaultDocument={DEFAULT_DOCUMENT}
    loadDocument={refundReturnApi.getRefundReturn}
    saveDocument={refundReturnApi.saveRefundReturn}
  />
);

export default RefundReturnEditor;
